// Menu bên trái và thẻ Thao tác nhanh dùng chung, phải khớp route trong App.tsx.
export const ADMIN_PATHS = {
  school: '/admin/school',
  class: '/admin/class',
  schoolTeachers: '/admin/school-teachers',
  schoolStudents: '/admin/school-students',
} as const;
